import { action, observable } from "mobx";
import NestStore from "~/stores/NestStore";
import CreditCardTransactionRepository from "~/repository/Credit/CreditCardTransactionRepository";
import CreditCardTransaction from "~/models/Credit/CreditCardTransaction";

class CreditCardTransactionStore extends NestStore {
  /**
   * @property {CreditCardTransaction}
   */
  @observable creditCardTransaction = null;

  /**
   * @private
   */
  #creditCardTransactionCopy;

  /**
   * @property {number}
   */
  creditCardTransactionId;

  creditCardTransactionRepository = null;

  constructor() {
    super();

    this.creditCardTransactionRepository = new CreditCardTransactionRepository();
  }

  @action
  load() {
    this.isLoading = true;

    return Promise.all([this.getOne()]).then(() => {
      this.isLoading = false;
    });
  }

  @action
  getOne() {
    return this.creditCardTransactionRepository.fetchOne(this.creditCardTransactionId).then(response => {
      this.creditCardTransaction = new CreditCardTransaction(response.data.creditCardTransaction);
    });
  }
}

export default CreditCardTransactionStore;
